import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { MysqlTableDataset } from 'app/model/dataset/mysql-table.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MysqlTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetAdapts,
        properties: {
            ...tabularTypeDatasetAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForMySql ? '*' : undefined
        }
    }
})
export class MysqlTableDatasetAdapter extends TabularTypeDatasetAdapter<MysqlTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MysqlTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MysqlTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MysqlTableDataset): Promise<MysqlTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MysqlTableDataset.MODEL);
    }
}
